"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var social_groups_api_1 = require("@wix/social-groups-api");
var BaseWidgetController_1 = require("@wix/social-groups-common/dist/src/BaseWidgetController");
var fixtures = require("./mocks");
var PubSubEventTypes_1 = require("../pubSub/PubSubEventTypes");
var main_1 = require("../main");
var routeParams_1 = require("../routeParams");
var helpers_1 = require("../helpers");
var GroupController = /** @class */ (function (_super) {
    tslib_1.__extends(GroupController, _super);
    function GroupController(controllerConfig, experiments) {
        var _this = _super.call(this, controllerConfig) || this;
        _this.experiments = experiments;
        _this.pageReady = function () { return tslib_1.__awaiter(_this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                this.setState({
                    locale: this.getLocale(),
                    cssBaseUrl: this.getCssBaseUrl(),
                    activeTab: this.getRouteParams().activeTab,
                    experiments: this.experiments,
                    changeTab: this.changeTab,
                    uploadedRegistry: [],
                    actions: {
                        changeTab: this.changeTab,
                        uploadFiles: this.uploadFiles,
                        changeMembership: this.changeMembership,
                    },
                    isLoggedIn: this.isUserLoggedIn(),
                    promptLogin: this.promptLogin,
                });
                if (this.isEditorMode()) {
                    return [2 /*return*/, this.mockGroup()];
                }
                return [2 /*return*/, this.populateGroupAndMembers(this.getRouteParams().groupId)];
            });
        }); };
        _this.uploadFiles = function (filename, file) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
            var uploadFile, data, e_1;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        uploadFile = { filename: filename, uploadResponse: null, error: null };
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, 4, 5]);
                        return [4 /*yield*/, this.mediaApi.uploadImage(file)];
                    case 2:
                        data = (_a.sent()).data;
                        uploadFile.uploadResponse = data;
                        return [3 /*break*/, 5];
                    case 3:
                        e_1 = _a.sent();
                        uploadFile.error = e_1;
                        return [3 /*break*/, 5];
                    case 4:
                        this.setState({ uploadedRegistry: [uploadFile] });
                        return [7 /*endfinally*/];
                    case 5: return [2 /*return*/];
                }
            });
        }); };
        _this.changeMembership = function () { return tslib_1.__awaiter(_this, void 0, void 0, function () {
            var group;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.isUserLoggedIn()) return [3 /*break*/, 3];
                        group = this.state.group;
                        return [4 /*yield*/, this.groupModel.changeMembership(group)];
                    case 1:
                        _a.sent();
                        return [4 /*yield*/, this.populateGroupAndMembers(group.groupId)];
                    case 2:
                        _a.sent();
                        return [3 /*break*/, 5];
                    case 3: return [4 /*yield*/, this.promptLogin()];
                    case 4:
                        _a.sent();
                        _a.label = 5;
                    case 5: return [2 /*return*/];
                }
            });
        }); };
        _this.handleLocationChange = function (_a) {
            var path = _a.path;
            var tab = path[2];
            _this.setState({
                activeTab: tab,
            });
        };
        _this.changeTab = function (tab) {
            if (_this.isEditorMode()) {
                return _this.setState({ activeTab: tab });
            }
            var location = _this.getLocation();
            var _a = _this.getRouteParams(), groupId = _a.groupId, section = _a.section;
            location.to("/" + section + "/" + groupId + "/" + tab);
        };
        var location = _this.getLocation();
        _this.state = {};
        _this.initExternalServices(_this.getSiteToken());
        location.onChange(_this.handleLocationChange);
        _this.onUserLogin(function (_a) {
            var instance = _a.instance;
            return tslib_1.__awaiter(_this, void 0, void 0, function () {
                return tslib_1.__generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            this.initExternalServices(instance);
                            return [4 /*yield*/, this.populateGroupAndMembers(this.getRouteParams().groupId)];
                        case 1:
                            _b.sent();
                            return [2 /*return*/];
                    }
                });
            });
        });
        _this.setSubscriptions();
        return _this;
    }
    GroupController.prototype.setState = function (props) {
        this.state = tslib_1.__assign({}, this.state, props);
        this.controllerConfig.setProps(props);
    };
    GroupController.prototype.mockGroup = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var firstGroup, e_2;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, helpers_1.getFirstGroup(this.apiClient)];
                    case 1:
                        firstGroup = _a.sent();
                        this.groupModel = new social_groups_api_1.Group(firstGroup.groupId, this.apiClient);
                        if (firstGroup) {
                            return [2 /*return*/, this.populateGroupAndMembers(firstGroup.groupId)];
                        }
                        this.setState(fixtures);
                        return [3 /*break*/, 3];
                    case 2:
                        e_2 = _a.sent();
                        main_1.MainController.logger.log('Group Controller error', e_2);
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    GroupController.prototype.populateGroupAndMembers = function (groupId) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _a, group, members;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!groupId) {
                            return [2 /*return*/];
                        }
                        this.setState({ loading: true });
                        return [4 /*yield*/, Promise.all([
                                this.groupModel.fetch(),
                                this.groupModel.getMembers(),
                            ])];
                    case 1:
                        _a = _b.sent(), group = _a[0], members = _a[1];
                        this.setState({
                            group: group,
                            members: members,
                            loading: false,
                            isLoggedIn: this.isUserLoggedIn(),
                        });
                        return [2 /*return*/];
                }
            });
        });
    };
    GroupController.prototype.getCssBaseUrl = function () {
        var _a = this.controllerConfig.appParams.baseUrls, staticsGroupBaseUrl = _a.staticsGroupBaseUrl, staticsBaseUrl = _a.staticsBaseUrl;
        return staticsGroupBaseUrl || staticsBaseUrl;
    };
    GroupController.prototype.getRouteParams = function () {
        var location = this.getLocation();
        return routeParams_1.groupRoute(location);
    };
    GroupController.prototype.initExternalServices = function (instance) {
        this.apiClient = new social_groups_api_1.default(instance, this.getApiBaseUrl());
        this.mediaApi = new social_groups_api_1.MediaApi(this.apiClient);
        this.groupModel = new social_groups_api_1.Group(this.getRouteParams().groupId, this.apiClient);
    };
    GroupController.prototype.setSubscriptions = function () {
        var _this = this;
        try {
            this.controllerConfig.platformAPIs.pubSub.subscribe(PubSubEventTypes_1.PubSubEventTypes.UPDATE_MEMBERS_EVENT, function () { return tslib_1.__awaiter(_this, void 0, void 0, function () {
                var _a, group, members, e_3;
                return tslib_1.__generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            _b.trys.push([0, 2, , 3]);
                            return [4 /*yield*/, Promise.all([
                                    this.groupModel.fetch(),
                                    this.groupModel.getMembers(),
                                ])];
                        case 1:
                            _a = _b.sent(), group = _a[0], members = _a[1];
                            this.setState({ members: members, group: group });
                            return [3 /*break*/, 3];
                        case 2:
                            e_3 = _b.sent();
                            return [3 /*break*/, 3];
                        case 3: return [2 /*return*/];
                    }
                });
            }); }, false);
        }
        catch (e) {
            main_1.MainController.logger.log(e);
        }
    };
    return GroupController;
}(BaseWidgetController_1.BaseWidgetController));
exports.GroupController = GroupController;
//# sourceMappingURL=controller.js.map